import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    showMoreButtonBox: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 16
    },
    showMoreButton: {
        [theme.breakpoints.up('sm')]: {
            width: 240
        }
    },
    upperSectionBox: {
        marginTop: 45,
        [theme.breakpoints.down('sm')]: {
            marginTop: 20
        }
    },
    sectionBox: {
        marginTop: 70
    },
    articleBox: {
        marginBottom: 30
    },
    schoolIndexChipsBox: {
        marginBottom: 45,
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    },
    subTitle: {
        fontSize: 18,
        marginBottom: 16
    },
    mainBox: {
        display: 'flex',
        gap: 48,
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column'
        }
    },
    rightBox: {
        minWidth: 300,
        width: 300,
        [theme.breakpoints.down('sm')]: {
            minWidth: 'unset',
            width: '100%'
        }
    },
    leftBox: {
        width: '100%'
    },
    recentNewsTitle: {
        marginBottom: 16
    }
}))
